/* RS Air Filter — PDP: vídeo inline na galeria (autoplay/mudo/loop, sem modal) */
(function(){
  function ratio(){
    var img=document.querySelector('.product__media-wrapper .swiper-main-prd .swiper-slide img');
    if(img&&img.naturalWidth&&img.naturalHeight){return img.naturalWidth+'/'+img.naturalHeight;}
    return '1/1';
  }
  function syncPlay(swEl){
    swEl.querySelectorAll('.swiper-slide video[data-rsvid]').forEach(function(v){
      var sl=v.closest('.swiper-slide');
      if(sl && sl.classList.contains('swiper-slide-active')){var p=v.play();if(p&&p.catch)p.catch(function(){});}
      else{v.pause();}
    });
  }
  function upgrade(dm){
    if(dm.dataset.rsInline)return;
    var tpl=dm.querySelector('template');
    if(!tpl)return;
    var html=tpl.innerHTML||'';
    if(!/<video/i.test(html))return;
    dm.dataset.rsInline='1';
    dm.setAttribute('data-rs-inline','');
    dm.innerHTML=html;
    dm.classList.remove('no-js-hidden');
    var v=dm.querySelector('video');
    if(!v)return;
    v.setAttribute('data-rsvid','');
    v.muted=true;v.loop=true;v.autoplay=true;v.controls=false;
    v.setAttribute('muted','');v.setAttribute('loop','');v.setAttribute('playsinline','');
    v.setAttribute('webkit-playsinline','');v.setAttribute('preload','auto');v.removeAttribute('controls');
    var host=dm.closest('.media-type-video')||dm;
    host.style.aspectRatio=ratio();
    host.style.overflow='hidden';
    try{v.load();}catch(e){}
    var swEl=dm.closest('.swiper');
    if(swEl){
      if(swEl.swiper){
        swEl.swiper.on('slideChange',function(){syncPlay(swEl);});
        swEl.swiper.on('slideChangeTransitionEnd',function(){syncPlay(swEl);});
      }
      syncPlay(swEl);
    } else {var p=v.play();if(p&&p.catch)p.catch(function(){});}
  }
  function run(root){
    (root||document).querySelectorAll('.product__media-wrapper media-gallery deferred-media').forEach(upgrade);
    var sw=document.querySelector('.product__media-wrapper .swiper-main-prd');
    if(sw)syncPlay(sw);
  }
  if(document.readyState!=='loading')run();
  document.addEventListener('DOMContentLoaded',function(){run();});
  document.addEventListener('shopify:section:load',function(e){run(e.target);});
})();

/* ===== Conversões/OEM: chips (marca + código), 3 formatos ===== */
(function(){
  function groupBySpace(seg){
    var toks=seg.split(/\s+/), out=[], cur=[], hasCode=false;
    toks.forEach(function(t){
      if(!t) return;
      var isBrand=/^[A-Za-zÀ-ÿ&.]{2,}$/.test(t);
      if(isBrand && cur.length && hasCode){ out.push(cur.join(' ')); cur=[]; hasCode=false; }
      cur.push(t);
      if(!isBrand) hasCode=true;
    });
    if(cur.length) out.push(cur.join(' '));
    return out;
  }
  function splitOem(raw){
    var out=[];
    raw.split(/\s*\/\s*|\r?\n/).forEach(function(seg){
      seg=(seg||'').replace(/\s+/g,' ').trim();
      if(!seg) return;
      groupBySpace(seg).forEach(function(c){ c=c.trim(); if(c) out.push(c); });
    });
    return out;
  }
  function build(root){
    (root||document).querySelectorAll('.rs-fp__chips[data-oem]').forEach(function(box){
      if(box.dataset.rsOemDone) return;
      var codes=splitOem(box.getAttribute('data-oem')||'');
      if(!codes.length) return;
      box.dataset.rsOemDone='1';
      box.innerHTML='';
      codes.forEach(function(c){ var s=document.createElement('span'); s.className='rs-fp__chip'; s.textContent=c; box.appendChild(s); });
    });
  }
  if(document.readyState!=='loading')build();
  document.addEventListener('DOMContentLoaded',function(){build();});
  document.addEventListener('shopify:section:load',function(e){build(e.target);});
})();

/* ===== Siblings de COR: deriva do handle (base + sufixo de cor) e monta cards com foto ===== */
(function(){
  var COLORS=[{k:'vermelho',n:'Vermelho'},{k:'azul',n:'Azul'},{k:'cinza',n:'Cinza'}];
  function esc(s){ return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }
  function withW(url,w){ if(!url) return ''; return url + (url.indexOf('?')>-1?'&':'?') + 'width='+w; }
  function currentHandle(){
    var m=location.pathname.match(/\/products\/([^\/?#]+)/);
    if(m) return m[1];
    var ex=document.getElementById('rs-buy-extras');
    return ex ? ex.getAttribute('data-handle') : null;
  }
  function build(){
    var box=document.querySelector('.rs-be__cor[data-rs-cor]');
    if(!box || box.dataset.rsCorDone) return;
    var h=currentHandle(); if(!h) return;
    var cur=null, base=null;
    COLORS.forEach(function(c){ var suf='-'+c.k; if(!cur && h.slice(-suf.length)===suf){ cur=c.k; base=h.slice(0,-suf.length); } });
    if(!base) return;
    box.dataset.rsCorDone='1';
    Promise.all(COLORS.map(function(c){
      var hh=base+'-'+c.k;
      return fetch('/products/'+hh+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.ok?r.json():null;}).catch(function(){return null;})
        .then(function(p){ return p?{k:c.k,n:c.n,handle:hh,img:(p.featured_image||(p.images&&p.images[0])||'')}:null; });
    })).then(function(list){
      var found=list.filter(Boolean);
      if(found.length<2) return;
      var curName=(COLORS.filter(function(c){return c.k===cur;})[0]||{}).n||'';
      var html='<span class="rs-be__cor-lbl">Cor:<b>'+esc(curName)+'</b></span><div class="rs-be__swatches">';
      found.forEach(function(f){
        var active=f.k===cur?' rs-be__sw--active':'';
        var img=f.img?'<img src="'+esc(withW(f.img,200))+'" alt="'+esc(f.n)+'" loading="lazy">':'';
        html+='<a class="rs-be__sw'+active+'" href="/products/'+esc(f.handle)+'"'+(active?' aria-current="true"':'')+'>'+img+'<em>'+esc(f.n)+'</em></a>';
      });
      html+='</div>';
      box.innerHTML=html; box.hidden=false;
    });
  }
  if(document.readyState!=='loading')build();
  document.addEventListener('DOMContentLoaded',build);
  document.addEventListener('shopify:section:load',build);
})();

/* ===== Área de compra: reposicionamento + compartilhar + pergunta + frete ===== */
(function(){
  function relocate(){
    var extras=document.getElementById('rs-buy-extras');
    if(extras && !extras.dataset.rsMoved){
      var col=document.querySelector('.tp-main-prd');
      var anchor=col && (col.querySelector('product-form') || col.querySelector('.tp-main-prd__price') || col.querySelector('.product__title'));
      if(anchor && anchor.parentNode){
        anchor.parentNode.insertBefore(extras, anchor.nextSibling);
        extras.dataset.rsMoved='1';
      }
    }
    var ask=document.querySelector('.rs-ask[data-rs-ask-overlay]');
    if(ask && ask.parentNode !== document.body){ document.body.appendChild(ask); }
  }
  function bindShare(extras){
    var btn=extras.querySelector('[data-rs-share]');
    var menu=extras.querySelector('[data-rs-share-menu]');
    if(!btn) return;
    var url=location.href.split('#')[0];
    var title=extras.dataset.produto||document.title;
    var wa=extras.querySelector('[data-rs-share-wa]');
    var fb=extras.querySelector('[data-rs-share-fb]');
    if(wa) wa.href='https://wa.me/?text='+encodeURIComponent(title+' '+url);
    if(fb) fb.href='https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url);
    btn.addEventListener('click',function(){
      if(navigator.share){ navigator.share({title:title,url:url}).catch(function(){}); }
      else if(menu){ menu.hidden=!menu.hidden; }
    });
    var copy=extras.querySelector('[data-rs-share-copy]');
    if(copy) copy.addEventListener('click',function(){
      (navigator.clipboard?navigator.clipboard.writeText(url):Promise.reject()).then(function(){copy.textContent='Link copiado!';setTimeout(function(){copy.textContent='Copiar link';},1800);}).catch(function(){});
    });
    document.addEventListener('click',function(e){ if(menu && !menu.hidden && !extras.querySelector('.rs-be__actions').contains(e.target)) menu.hidden=true; });
  }
  function bindAsk(extras){
    var open=extras.querySelector('[data-rs-ask]');
    var ov=document.querySelector('.rs-ask[data-rs-ask-overlay]');
    if(!open || !ov) return;
    var wa=extras.dataset.wa, email=extras.dataset.email, prod=extras.dataset.produto;
    var waLink=ov.querySelector('[data-rs-ask-wa]');
    if(waLink) waLink.href='https://wa.me/'+wa+'?text='+encodeURIComponent('Olá! Tenho uma dúvida sobre: '+prod);
    function show(){ ov.hidden=false; document.documentElement.style.overflow='hidden'; }
    function hide(){ ov.hidden=true; document.documentElement.style.overflow=''; }
    open.addEventListener('click',show);
    ov.querySelector('[data-rs-ask-close]').addEventListener('click',hide);
    ov.addEventListener('click',function(e){ if(e.target===ov) hide(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !ov.hidden) hide(); });
    var form=ov.querySelector('[data-rs-ask-form]');
    if(form) form.addEventListener('submit',function(e){
      e.preventDefault();
      var f=e.target;
      var nome=f.nome.value, mail=f.email.value, msg=f.msg.value;
      var sub='Dúvida sobre '+prod;
      var body='Produto: '+prod+'\nNome: '+nome+'\nE-mail: '+mail+'\n\n'+msg+'\n\nEnviado de: '+location.href;
      window.location.href='mailto:'+email+'?subject='+encodeURIComponent(sub)+'&body='+encodeURIComponent(body);
    });
  }
  function bindShip(extras){
    var form=extras.querySelector('[data-rs-ship]');
    if(!form) return;
    var input=extras.querySelector('[data-rs-cep]');
    var res=extras.querySelector('[data-rs-ship-result]');
    var price=parseInt(extras.dataset.price||'0',10);
    var lim=parseInt(extras.dataset.freteGratis||'0',10);
    input.addEventListener('input',function(){
      var d=input.value.replace(/\D/g,'').slice(0,8);
      input.value = d.length>5 ? d.slice(0,5)+'-'+d.slice(5) : d;
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var cep=input.value.replace(/\D/g,'');
      if(cep.length!==8){ res.hidden=false; res.className='rs-be__ship-result'; res.innerHTML='Digite um CEP válido (8 dígitos).'; return; }
      res.hidden=false; res.className='rs-be__ship-result'; res.innerHTML='Consultando...';
      fetch('https://viacep.com.br/ws/'+cep+'/json/').then(function(r){return r.json();}).then(function(d){
        if(d.erro){ res.innerHTML='CEP não encontrado. Confira e tente de novo.'; return; }
        var dest='<strong>'+(d.localidade||'')+' / '+(d.uf||'')+'</strong>';
        res.innerHTML='Enviamos para '+dest+'<br>O valor e o prazo do frete aparecem no checkout.<br>Saída em 24h úteis + prazo da transportadora.';
      }).catch(function(){ res.innerHTML='Não foi possível consultar agora. Tente novamente.'; });
    });
  }
  function initBuy(){
    relocate();
    var extras=document.getElementById('rs-buy-extras');
    if(!extras || extras.dataset.rsBuyInit) return;
    extras.dataset.rsBuyInit='1';
    bindShare(extras); bindAsk(extras); bindShip(extras);
  }
  if(document.readyState!=='loading')initBuy();
  document.addEventListener('DOMContentLoaded',initBuy);
  document.addEventListener('shopify:section:load',initBuy);
})();
